import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { IOsaExecucaoFolhaTesteQuestaoModel, IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoModel, IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoArquivoModel } from "./../../../../../models/osa-execucao-folha-teste-model";
import { OsaExecucaoFolhaTesteService } from "./../../../../../services/osa-execucao-folha-teste.service";
import Swal from "sweetalert2";
import { AuthService } from "./../../../../../services/auth.service";
import { EAvaliacaoFolhaTesteQuestao, EAvaliacaoFolhaTesteQuestaoDescricao } from "../../../../../models/enum/avaliacao-folha-teste-questao.enum";
import { OsaExecucaoPapelTrabalhoService } from "./../../../../../services/osa-execucao-papel-trabalho.service";
import { IOsaExecucaoPapelTrabalho, IOsaExecucaoPapelTrabalhoArquivo } from "./../../../../../models/osa-execucao-papel-trabalho.model";

@Component({
  selector: 'app-osa-execucao-aba-folha-teste-questao-responder',
  templateUrl: './osa-execucao-aba-folha-teste-questao-responder.component.html',
  styleUrls: ['./osa-execucao-aba-folha-teste-questao-responder.component.scss']
})
export class OsaExecucaoAbaFolhaTesteQuestaoResponderComponent implements OnInit {

  public dataSourceEvidencias = new MatTableDataSource<IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoModel>([]);
  public semDados: boolean = false;
  public model: IOsaExecucaoFolhaTesteQuestaoModel = {} as IOsaExecucaoFolhaTesteQuestaoModel;
  public tituloModal = "";
  public visualizar = false;
  public alterandoEvidencia: boolean = false;
  public id: number = 0;
  public osaExecucaoId: number = 0;

  public enumAvaliacaoFolhaTesteQuestao = EAvaliacaoFolhaTesteQuestao;
  public avaliacoesFolhaTesteQuestao: { text: string, value: number }[] = [];
  public listaEvidencias: IOsaExecucaoPapelTrabalho[];
  public listaEvidenciasArquivos: IOsaExecucaoPapelTrabalhoArquivo[];
  public evidenciaSelecionada: number | null = null;
  public arquivosSelecionados: number[];


  constructor(
    public matDialog: MatDialog,
    public osaExecucaoFolhaTesteService: OsaExecucaoFolhaTesteService,
    public osaExecucaoPapelTrabalhoService: OsaExecucaoPapelTrabalhoService,
    public authService: AuthService,
    private dialogRef: MatDialogRef<OsaExecucaoAbaFolhaTesteQuestaoResponderComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.osaExecucaoId = data?.osaExecucaoId;
    this.id = data?.id;
    this.visualizar = data?.visualizar;
  }

  @ViewChild("tabelaPapelTrabalhoPaginator", { static: true })
  tabelaPapelTrabalhoPaginator: MatPaginator;
  @ViewChild("tabelaPapelTrabalhoSort", { static: true })
  tabelaPapelTrabalhoSort: MatSort;

  public habilitaFinalizar: boolean = false;

  public valorObservacaoOriginal!: string;
  public valorAvaliacaoOriginal: number | null = null;
  public evidenciasOriginal: IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoModel[] = [];

  ngOnInit(): void {
    if (this.visualizar) this.tituloModal = "Visualizar Questão ou Procedimento";
    else this.tituloModal = "Responder Questão ou Procedimento";

    this.carregarListaAvaliacao();

    this.obter(this.id);

    this.dataSourceEvidencias.paginator = this.tabelaPapelTrabalhoPaginator;
    this.dataSourceEvidencias.sort = this.tabelaPapelTrabalhoSort;
    this.dataSourceEvidencias.sortingDataAccessor = this.sortingDataAccessor;
  }

  public carregarListaAvaliacao() {
    this.avaliacoesFolhaTesteQuestao = Object.keys(this.enumAvaliacaoFolhaTesteQuestao)
      .filter(key => !isNaN(Number(key)))
      .map(key => ({
        text: EAvaliacaoFolhaTesteQuestaoDescricao[Number(key) as EAvaliacaoFolhaTesteQuestao] ?? '',
        value: Number(key)
      }));
  }

  public obter(id: number) {

    this.osaExecucaoFolhaTesteService
      .obterFolhaTesteQuestaoPorId(id)
      .then((res) => {
        if (res.sucesso) {

          this.model = res.dados;
          this.dataSourceEvidencias.data = res?.dados?.evidencias;
          this.dataSourceEvidencias.paginator = this.tabelaPapelTrabalhoPaginator;
          this.dataSourceEvidencias.sort = this.tabelaPapelTrabalhoSort;
          this.dataSourceEvidencias.sortingDataAccessor = this.sortingDataAccessor;
          this.valorObservacaoOriginal = this.model?.observacao ?? null;
          this.valorAvaliacaoOriginal = this.model?.avaliacao ?? null;
          this.evidenciasOriginal = [...res?.dados?.evidencias];

          this.verificaAlteracao();

          this.carregarListaEvidencia();

        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }

  public finalizar() {

    if (!this.model.avaliacao) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Informe a avaliação para Finalizar!",
      });
      return;
    }

    if ((!this.model.observacao || this.model.observacao === "") && this.dataSourceEvidencias.data.length === 0) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Na falta de evidências, informe a observação para finalizar!",
      });
      return;
    }

    Swal.fire({
      title: "Finalizar Questão/Procedimento",
      text: "Confirma finalização da Questão/Procedimento?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.value) {

        const responsavelId = this.authService.usuario.id;
        this.model.responsavelId = responsavelId;
        this.model.status = 2;

        this.osaExecucaoFolhaTesteService
          .atualizarFolhaTesteQuestao(this.model)
          .then((res) => {
            if (res.sucesso) {

              this.dialogRef.close(true);

              Swal.fire({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                icon: "success",
                text: res.mensagem.descricao,
              });
            } else {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "warning",
                text: res.mensagem.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            }
          }).finally(() => {
          });
      }
    })
  }

  public salvar(fechar: boolean) {

    if ((!this.model.observacao || this.model.observacao === "" || this.model.observacao === undefined) && !this.model.avaliacao && this.dataSourceEvidencias.data.length === 0) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "É necessário preencher pelo menos uma informação para salvar o registro!",
      });
      return;
    }

    const responsavelId = this.authService.usuario.id;
    this.model.responsavelId = responsavelId;

    if (this.model.status === 2)
      this.model.status = 1;

    this.osaExecucaoFolhaTesteService
      .atualizarFolhaTesteQuestao(this.model)
      .then((res) => {
        if (res.sucesso) {

          if (fechar)
            this.dialogRef.close(true);
          else
            this.obter(this.id);

          Swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            icon: "success",
            text: res.mensagem.descricao,
          });
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }

  public sortingDataAccessor = (item, property) => {
    switch (property) {
      case "arquivo":
        return item.nomeArquivo;
      default:
        return item[property];
    }
  };

  public carregarListaEvidencia(): Promise<void> {

    return this.osaExecucaoPapelTrabalhoService
      .obterPorExecucao(this.osaExecucaoId)
      .then((res) => {
        if (res.sucesso) {

          // Lista retornada do backend
          const listafull = res.dados.filter((item: any) => item.id > 0) || [];

          // IDs já utilizados (presentes na model.evidencias)
          const idsUsados = this.model.evidencias?.map((x) => x.osaExecucaoPapelTrabalhoId) ?? [];

          // Filtra apenas os itens que ainda não foram adicionados
          this.listaEvidencias = listafull.filter((item: any) => !idsUsados.includes(item.id));

        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }

  public obterArquivosDaEvidencia(id: number) {
    this.arquivosSelecionados = [];
    const evidenciaSelecionada = this.listaEvidencias?.find(e => e.id === id);
    this.listaEvidenciasArquivos = evidenciaSelecionada?.arquivos ? evidenciaSelecionada.arquivos : [];
  }

  public addEvidencia() {

    if (!this.evidenciaSelecionada) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Selecione a Evidência para incluir!",
      });
      return;
    }

    //-> antes de adicionar a evidencia, verifica se ja existe, 
    // pois a origem dessa ação pode ser após uma alteração da evidencia
    const idx = this.model.evidencias?.findIndex(x => x.osaExecucaoPapelTrabalhoId === this.evidenciaSelecionada);
    if (idx !== undefined && idx > -1) {
      this.model.evidencias?.splice(idx, 1);
    }

    // adiciona na grade
    const evidenciaSelecionada = this.listaEvidencias?.find(e => e.id === this.evidenciaSelecionada);

    //-> cria uma lista com os arquivos selecionados
    var arquivosEvidencia: IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoArquivoModel[] = [];

    if (this.arquivosSelecionados?.length > 0) {

      this.arquivosSelecionados.forEach((id: number) => {
        var arquivo = this.listaEvidenciasArquivos.find(a => a.id == id)!;
        const novoArquivo: IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoArquivoModel = {
          id: 0,
          osaExecucaoFolhaTesteQuestaoPapelTrabalhoId: 0,
          osaExecucaoPapelTrabalhoArquivoId: arquivo.id,
          osaExecucaoPapelTrabalhoArquivo: {
            id: arquivo.id,
            osaExecucaoPapelTrabalhoId: arquivo?.osaExecucaoPapelTrabalhoId,
            nome: arquivo.nome,
            tipo: arquivo.tipo,
            arquivo: arquivo.arquivo
          }
        };
        arquivosEvidencia.push(novoArquivo);
      });
    }

    const novaEvidencia: IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoModel = {
      id: 0,
      osaExecucaoFolhaTesteQuestaoId: this.id,
      osaExecucaoPapelTrabalhoId: evidenciaSelecionada?.id!,
      osaExecucaoPapelTrabalho: evidenciaSelecionada!,
      arquivos: arquivosEvidencia
    };

    this.model.evidencias.push(novaEvidencia);
    this.dataSourceEvidencias.data = [...this.model.evidencias];

    // atualiza a combo
    this.carregarListaEvidencia();

    // limpa a seleção da combo
    this.evidenciaSelecionada = null;
    this.arquivosSelecionados = [];

    this.alterandoEvidencia = false;

    // desabilita o finalizar
    this.verificaAlteracao();
  }

  public alterarEvidencia(element: IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoModel) {

    //-> devolver a evidencia para a combo 
    return this.osaExecucaoPapelTrabalhoService
      .obterPorExecucao(this.osaExecucaoId)
      .then((res) => {
        if (res.sucesso) {

          // Lista retornada do backend
          const listafull = res.dados.filter((item: any) => item.id > 0) || [];

          // IDs já utilizados (presentes na model.evidencias, exceto o que está sendo alterado)
          const idsUsados = this.model.evidencias?.map((x) => x.osaExecucaoPapelTrabalhoId !== element.osaExecucaoPapelTrabalhoId) ?? [];

          // Filtra apenas os itens que ainda não foram adicionados e o que está sendo alterado
          this.listaEvidencias = listafull.filter((item: any) => !idsUsados.includes(item.id));

          // Posiciona a combo no registro que esta sendo alterado 
          this.evidenciaSelecionada = element.osaExecucaoPapelTrabalhoId;

          this.obterArquivosDaEvidencia(this.evidenciaSelecionada);

          // Preenche a combo de arquivos com os arquivos da evidencia que esta sendo alterada
          this.arquivosSelecionados = element.arquivos.map(a => a.osaExecucaoPapelTrabalhoArquivoId);

          this.alterandoEvidencia = true;

        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }


  public excluirEvidencia(element: IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoModel) {

    Swal.fire({
      title: "Excluir Evidência?",
      text: "Confirma exclusão da evidência?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.value) {

        //-> remove da grade 
        const idx = this.model.evidencias?.findIndex(x => x.id === element.id);
        if (idx !== undefined && idx > -1) {
          this.model.evidencias?.splice(idx, 1);
          this.dataSourceEvidencias.data = [...this.model.evidencias];
        }

        this.alterandoEvidencia = false;

        //-> atualiza a combo
        this.carregarListaEvidencia();
        
        // desabilita o finalizar
        this.verificaAlteracao();
      }
    });
  }

  public download(arquivo: IOsaExecucaoPapelTrabalhoArquivo) {
    this.osaExecucaoPapelTrabalhoService.downloadAnexo(arquivo.id).then((res) => {
      if (res.sucesso) {
        const link = document.createElement("a");
        link.href = res.dados.toString(); 0
        link.download = arquivo.nome;
        link.click();
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    })
  }

  public fechar() {
    this.dialogRef.close(!this.visualizar);
  }

  verificaAlteracao() {

    const normalizar = (valor: any) => {
      if (valor === undefined || valor === null) return null; // trata undefined e null como iguais
      if (typeof valor === 'string') {
        const texto = valor.trim();
        return texto === '' ? null : texto; // trata string vazia como null
      }
      return valor; // mantém outros tipos (número, boolean, etc.)
    };

    const observacaoIgual =
      normalizar(this.model.observacao) === normalizar(this.valorObservacaoOriginal);

    const avaliacaoIgual =
      normalizar(this.model.avaliacao) === normalizar(this.valorAvaliacaoOriginal);

    const evidenciasIguais =
      JSON.stringify(this.model.evidencias ?? []) ===
      JSON.stringify(this.evidenciasOriginal ?? []);

    this.habilitaFinalizar = observacaoIgual && avaliacaoIgual && evidenciasIguais;
  }

  getDescricaoQuestao(element: any): string {

    if (element.questaoId) {

      if (element.procedimentoAuditoria?.nome) {
        return element.procedimentoAuditoria.nome;
      }

      if (element.questao?.nome) {
        return element.questao.nome;
      }

      return '-';
    }

    if (element.descricaoProcedimentoQI) {
      return element.descricaoProcedimentoQI;
    }

    if (element.descricaoQI) {
      return element.descricaoQI;
    }

    return '-';
  }  

}

